import React from "react";
import { Parallax, Background } from "react-parallax";
import imageBlackwhite1 from '../images/imageBlackwhite1.jpg';
import imageTyping from '../images/imageTyping.jpg';
import { Box, Center, VStack } from "@chakra-ui/layout";

const image1 = imageTyping

export default function BlackwhiteParallax () {
  return ( 
  
  <Box w='1980px' h='1280px'>
    <Parallax bgImage={image1} strength={500}>
        <Box w='100%' h='700px'>
        {/* <Box bg="white" padding='20px' pos="absolute" top="50%" left="50%" transform="translate(-50%,-50%)">HTML inside the parallax</Box> */}
        </Box>
    </Parallax>
    </Box>
)};
